import { KYMW0900Model } from "../kymw0900.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { GetPreOrderRequestModel } from '../vo/kymw0900-get-pre-order-request.model';

/**
 * 予約設定情報取得サービス
 *
 * @export GetPreOrderService
 * @class GetPreOrderService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPreOrderService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPreOrderService
   */
  private successFunc: Function;

  model: KYMW0900Model;
  vo: GetPreOrderRequestModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPreOrderService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        PCodeCommon: {
          condition: {
            OrderCode: this.vo.orderCode,
            PCode: this.vo.pCode,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPreOrderService
   */
  execute(model: any, vo: GetPreOrderRequestModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getPreOrder', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPreOrderService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.setPreOrder(data);
      if (this.successFunc) {
        this.successFunc(data);
      }
    }
  }
}
